/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../config/screen';

/*
  Container for the entire component. Aligns children in the center both vertically and horizontally
  and arranges them in a column.
*/
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .ant-progress-circle {
    position: relative;
  };
`;

/*
  Wrapper for the content to maintain relative positioning.
*/
export const ContentContainer = styled.div`
  position: relative;
`;

/*
  SVG container for gradient definitions.
  Hidden from view but provides gradient definitions for the speedometer.
*/
export const GradientDefinitions = styled.svg`
  height: 0;
  position: absolute;
  width: 0;
`;

/*
  Wrapper for the speedometer progress with gradient effects.
  Applies different gradients based on the speedometer state (normal, warning, alarm, off).
  Similar to ProgressThermometer in VibrationThermometer component.
*/
export const ProgressSpeedometer = styled.div`
  /* Apply gradient based on threshold state */
  &.normal .ant-progress-circle-path {
    stroke: url(#speedometer-gradient-normal) !important;
  };

  &.warning .ant-progress-circle-path {
    stroke: url(#speedometer-gradient-warning) !important;
  };

  &.alarm .ant-progress-circle-path {
    stroke: url(#speedometer-gradient-alarm) !important;
  };

  &.off .ant-progress-circle-path {
    stroke: ${({ theme }) => theme.color.speedometer.offProgressBackgroundColor} !important;
  };
`;

/*
  Container for displaying the data value, centered horizontally.
*/
export const DataValue = styled.div`
  display: flex;
  justify-content: center;
`;

/*
  Container for displaying the unit type, centered horizontally.
*/
export const UnitType = styled.div`
  display: flex;
  justify-content: center;
`;

/*
  Container for the title, centered horizontally with padding on top.
*/
export const TitleContainer = styled.div`
  text-align: center;
  padding-top: 10px;
  display: flex;
  justify-content: center;
  width: max-content;
`;

/*
  Container for the minimum value, positioned absolutely at the bottom left.
*/
export const MinValueContainer = styled.div`
  position: absolute;
  bottom: 20px;
  left: 4px;
  z-index: 1;
`;

/*
  Tick mark for the minimum value, rotated to align correctly.
*/
export const MinValueTick = styled.div`
  position: absolute;
  width: 2px;
  height: 8px; 
  background-color: ${({ theme }) => theme.color.speedometer.ticksBackgroundColor};
  transform: rotate(-125deg);
  margin-left: -2px;
  margin-top: 4px;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    height: 8px;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    margin-left: 0;
    margin-top: 0;
  };
`;

/*
  Numerical display for the minimum value, positioned absolutely below the tick.
  Aligned by the last digit (right edge), text grows to the left.
*/
export const MinValueNumber = styled.div`
  position: absolute;
  bottom: -27px;
  right: 7px;
  width: max-content;
  
  @media (min-width: ${BREAKPOINTS.sm}px) {
    bottom: -25px;
  };
`;

/*
  Container for the maximum value, positioned absolutely at the bottom right.
*/
export const MaxValueContainer = styled.div`
  position: absolute;
  right: 6px;
  bottom: 20px;
  z-index: 1;
`;

/*
  Tick mark for the maximum value, rotated to align correctly.
*/
export const MaxValueTick = styled.div`
  position: absolute;
  width: 2px; 
  height: 8px;
  background-color: ${({ theme }) => theme.color.speedometer.ticksBackgroundColor};
  transform: rotate(125deg);
  margin-left: 2px;
  margin-top: 4px;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    margin-left: 0;
    margin-top: 0;
  };
`;

/*
  Numerical display for the maximum value, positioned absolutely below the tick.
*/
export const MaxValueNumber = styled.div`
  position: absolute;
  height: max-content;
  left: 7px;
  width: max-content;
  bottom: -27px;
  
  @media (min-width: ${BREAKPOINTS.sm}px) {
    bottom: -25px;
  };
`;
